import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { ProductAttributes } from "./ProductAttributes";
import { ProductList } from "./ProductList";
import { FileText, Package } from "lucide-react";

export function ProductSettings() {
  return (
    <div className="space-y-4">
      <div>
        <h3 className="text-lg font-medium">產品設定</h3>
        <p className="text-sm text-muted-foreground">
          管理產品屬性和產品列表
        </p>
      </div>

      <Tabs defaultValue="attributes" className="w-full">
        <TabsList className="grid w-full grid-cols-2 max-w-md">
          <TabsTrigger value="attributes" className="flex items-center gap-2">
            <FileText className="h-4 w-4" />
            產品屬性
          </TabsTrigger>
          <TabsTrigger value="list" className="flex items-center gap-2">
            <Package className="h-4 w-4" />
            產品列表
          </TabsTrigger>
        </TabsList>

        <TabsContent value="attributes" className="mt-6">
          <ProductAttributes />
        </TabsContent>

        <TabsContent value="list" className="mt-6">
          <ProductList />
        </TabsContent>
      </Tabs>
    </div>
  );
}